import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DialogService } from '../../shared/components/dialog/dialog.service';
import { AuthService } from '../../_services/auth.service';
import { ApiService } from '../../_services/api.service';
import { User } from '../../_interfaces/user';
import { Template } from '../../_interfaces/template';
import { FormsModule } from '@angular/forms';
import { DefaultTemplateComponent } from '../../shared/dialogs/default-template/default-template.component';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultTemplate } from '../../_interfaces/user-settings.interface';
import { FeatureFlagsService } from '../../_services/feature-flags.service';
import { DefaultStyleSettingsComponent } from './default-style-settings/default-style-settings.component';

@Component({
  selector: 'app-settings-templates',
  standalone: true,
  imports: [
    CommonModule, 
    MatFormFieldModule, 
    MatSelectModule, 
    MatButtonModule,
    MatIconModule,
    FormsModule,
    TranslateModule,
    DefaultStyleSettingsComponent,
  ],
  templateUrl: './templates.component.html',
  styles: `
    .mat-mdc-outlined-button.low-padding {
      padding-inline: 12px;
    }
  `
})
export class SettingsTemplatesComponent implements OnInit {
  @ViewChild('templatesTop') templatesTop?: ElementRef<HTMLElement>;

  user: User | null = null;
  allTemplates: Template[] = [];
  userTemplates: Template[] = [];
  selectedTemplates: DefaultTemplate[] = [];
  selectedLanguage: string = 'en-US';

  showAll = false;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private dialog: DialogService,
    private flags: FeatureFlagsService
  ) {
    this.user = this.authService.getUser();
  }

  get showNoteGenerationSettings(): boolean {
    return this.flags.isEnabled('noteGenerationSettings');
  }

  async ngOnInit() {
    if (this.user?.settings?.copilotTemplates) {
      this.selectedTemplates = [...this.user.settings.copilotTemplates];
    }
    await this.loadTemplates();
    this.filterTemplates();
  }

  async loadTemplates() {
    this.allTemplates = await this.apiService.getCopilotTemplates();
  }

  filterTemplates() {
    if (this.user?.settings?.copilotTemplates && this.allTemplates) {
      const blueprintsEnabled = this.authService.isAiBlueprintsEnabled;
      this.userTemplates = this.allTemplates.filter(template => {
          if (!blueprintsEnabled && template.type === 'user') {
            return false;
          }
          return this.user?.settings?.copilotTemplates?.some(
          userTemplate => userTemplate.id === Number(template.id) && userTemplate.type === template.type
          );
      });
    }
  }

  openTemplateSelector(): void {
    const dialogRef = this.dialog.open(DefaultTemplateComponent, {
      size: 'mdPlus',
      maxHeight: '100vh',
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result?.templates) {
        // Refresh user data and templates
        this.user = this.authService.getUser();
        await this.filterTemplates();
      }
    });
  }

  toggleTemplates(): void {
    const wasShowingAll = this.showAll;
    this.showAll = !this.showAll;

    if (wasShowingAll) {
      setTimeout(() => {
        this.templatesTop?.nativeElement.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
      });
    }
  }
}
